import { makeStyles } from '@material-ui/core/styles'

export default makeStyles(theme => ({
  root: {
    width: '100%',
    position: 'relative',
    paddingTop: '100px',
    paddingBottom: '50px',
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'nowrap',
    justifyContent: 'center',
    alignItems: 'center'
  },
  container: {
    width: '100%',
    [theme.breakpoints.up('md')]: {
      maxWidth: '1140px'
    },
    [theme.breakpoints.down('md')]: {
      maxWidth: '960px'
    },
    [theme.breakpoints.down('sm')]: {
      maxWidth: '720px'
    },
    [theme.breakpoints.down('xs')]: {
      maxWidth: '540px'
    }
  }
}))
